import script from "./AddCustomerServices.vue?vue&type=script&setup=true&lang=js"
export * from "./AddCustomerServices.vue?vue&type=script&setup=true&lang=js"

import "./AddCustomerServices.vue?vue&type=style&index=0&id=25e1c3bb&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25e1c3bb"]])

export default __exports__